import React from 'react';
import {
  design_the_layout_key,
  enter_between,
  getSubCategoryId,
  Multiple_accounts,
  number_50_00,
  packageList,
  plans,
  select_package_configuration_key,
} from '../utils/DictionaryManagementUtils';
import SimulatorsViewerArrangement
  from '../components/SimulatorsComponents/FullPagesComponents/SimulatorsViewerArrangement';
import SelectPackageFP from '../components/SimulatorsComponents/FullPagesComponents/Services/Amount/SelectPackageFP';
import EnterAmountDF from '../components/SimulatorsComponents/DefualtSimulators/EnterAmountDF';
import AmountMenuFP from '../components/SimulatorsComponents/FullPagesComponents/Services/Amount/AmountMenuFP';

const Sim_H08_TopUpSelectPackage = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const { amount_package } = globJSON.configurations.services[subCategoryId];
  const numberColumns = () => {
    switch (amount_package.package_layout_columns) {
      default:
      case design_the_layout_key.column_1:
        return 1;
      case design_the_layout_key.column_2:
        return 2;
      case design_the_layout_key.column_3:
        return 3;
    }
  };
  const headlineText = amount_package.select_mobile_package_title;

  return (
    amount_package.package_configuration === select_package_configuration_key.manual_amount
      ? (
        <EnterAmountDF
          globJSON={globJSON}
          selectedScreen={selectedScreen}
          simPlatform={simPlatform}
          amount={amount_package}
          slideshowRefs={slideshowRefs}
        />
      )
      : (
        <SimulatorsViewerArrangement>
          <SelectPackageFP
            globJSON={globJSON}
            simPlatform={simPlatform}
            headlineText={headlineText}
            packageList={packageList}
            numberColumns={numberColumns()}
            layoutAligned={amount_package.package_layout_aligned}
            topTitle={plans}
            showExpendPackage={amount_package.package_configuration === select_package_configuration_key.both}
            showAccountBalance={amount_package.show_account_balance}
            slideshowRefs={slideshowRefs}
          />
          {amount_package.package_configuration === select_package_configuration_key.both
                    && (
                    <AmountMenuFP
                      amount={amount_package}
                      globJSON={globJSON}
                      simPlatform={simPlatform}
                      subCategoryId={subCategoryId}
                      showAccountBalance={amount_package.show_account_balance}
                      priceAmount={number_50_00}
                      showConvert={amount_package.enable_additional_instruction && enter_between}
                      IconBackgroundColor={globJSON.configurations.theme.colors.primary_cta_color}
                      showExpendBox
                      strTitle={Multiple_accounts}
                      slideshowRefs={slideshowRefs}
                    />
                    )}
        </SimulatorsViewerArrangement>
      )
  );
};

export default Sim_H08_TopUpSelectPackage;
